import baseApi from "./baseApi.js";
import axios from '@/models/API/axios'
import * as apiUrl from './apiUrl.js';

/**
 * 業務人api
 */
class businessInfoApi extends baseApi {
    constructor() {
        super();
        this.baseApi = new baseApi();
    }

    /**
     * 查詢要助人個人資訊
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getBusinessPersonalInfo(callback = {}, params = {}) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_BUSINESS_PERSONAL_INFO}`,
            params: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 查詢直推契約
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getDirectPushContract(callback = {}, params = {}) {
      const options = {
			method: this.request.method.get,
			url: `${apiUrl.API_GET_DIRECT_PUSH_CONTRACT}`,
			params: params,
			is_loading: true,
			headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

	  /**
     * 查詢直推契約
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getDirectPushReturnPiece(callback = {}, params = {}) {
      const options = {
			method: this.request.method.get,
			url: `${apiUrl.API_GET_DIRECT_PUSH_RETURN_PIECE}`,
			params: params,
			is_loading: true,
			headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 查詢業務樹狀圖
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getSalesTree(callback = {}, params = {}) {
        const options = {
        method: this.request.method.post,
        url: `${apiUrl.API_POST_SALES_TREE}`,
        params: params,
        is_loading: true,
        headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 查詢直推會員未繳明細表
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    getMemberUnpaid(callback = {}, params = {}, is_loading = true) {
        const options = {
        method: this.request.method.get,
        url: `${apiUrl.API_GET_DIRECT_PUSH_MEMBER_UNPAID}`,
        params: params,
        is_loading: is_loading,
        headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }


}

export default businessInfoApi;



// WEBPACK FOOTER //
// ./src/models/API/businessInfoApi.js